import { ComponentIds, ProductUtils, ValidationResultFail, } from "@inter-ikea-core/core";
import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { productSnapsAtValidHeight } from "./validationZoneUtils";
export class HeightRestrictionValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.name = "HeightRestrictionValidation";
        this.id = "HEIGHT_RESTRICTION_VALIDATION";
    }
    validateCurrentState(_entity) {
        return null;
    }
    validateSnap(Snap) {
        var _a, _b;
        const entity = Snap.guestRoot;
        const heightRestriction = (_b = (_a = entity.getComponent(ComponentIds.META_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.metaData) === null || _b === void 0 ? void 0 : _b.heightRestriction;
        if (!heightRestriction)
            return null;
        const { validPlacements } = heightRestriction;
        if (productSnapsAtValidHeight(entity, Snap, validPlacements))
            return null;
        return new ValidationResultFail("Invalid position for product", ProductUtils.productRefOrEmptyString(entity));
    }
}
